import React, { Component } from "react";
import { Row, Col, Form, Input, } from "antd";
import SelectUSState from "./select/initializedSelectUSState";

class FormItemAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Street Line 1"
                            name={this.props.streetLine1}
                            rules={[{ required: true }]}
                            initialValue={this.props.streetLine1InitialValue}
                            onChange={this.props.onChange(this.props.streetLine1)}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {this.props.streetLine2 !== undefined ? (
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Street Line 2"
                                name={this.props.streetLine2}
                                initialValue={this.props.streetLine2InitialValue}
                                onChange={this.props.onChange(
                                    this.props.streetLine2
                                )}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="City"
                            name={this.props.city}
                            rules={[{ required: true }]}
                            initialValue={this.props.cityInitialValue}
                            onChange={this.props.onChange(this.props.city)}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="State"
                            name={this.props.state}
                            rules={[{ required: true }]}
                            key={this.props.stateInitialValue}
                            initialValue={this.props.stateInitialValue}
                        >
                            <SelectUSState
                                formType={this.props.formType ? this.props.formType : ""}
                                initialValue={this.props.stateInitialValue}
                                onChange={this.props.onChange(this.props.state)}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="Zip Code"
                            name={this.props.zipCode}
                            initialValue={this.props.zipCodeInitialValue}
                            onChange={this.props.onChange(this.props.zipCode)}
                            rules={[
                                { required: true },
                                {
                                    pattern: /^\d+$/,
                                    message: "Zip Code must be a number",
                                },
                                {
                                    min: 5,
                                    max: 5,
                                    message: "Zip Code must be 5 characters.",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </>
        );
    }
}

export default FormItemAddress;
